import React from 'react';
import { ConfigProvider } from 'antd';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { DashboardLayout } from './layouts/DashboardLayout';
import { DashboardHome } from './pages/DashboardHome';
import { LanguagesPage } from './pages/LanguagesPage';
import { SubantasPage } from './pages/SubantasPage';
import { SubantaViewPage } from './pages/SubantaViewPage';
import { SubantaRupFormulaPage } from './pages/SubantaRupFormulaPage';
import { TingantasPage } from './pages/TingantasPage';
import { AmarkoshaPage } from './pages/AmarkoshaPage';
import { ShivaSutraPage } from './pages/ShivaSutraPage';
import { AshtadhyayiPage } from './pages/AshtadhyayiPage';
import { BarnaPage } from './pages/BarnaPage';
import { BarnaSamuhaPage } from './pages/BarnaSamuhaPage';
import { GanaPage } from './pages/GanaPage';
import { PratyaharPage } from './pages/PratyaharPage';
import { UpasargasPage } from './pages/UpasargasPage';
import { SutraCommentaryPage } from './pages/SutraCommentaryPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import './App.css';

function HomeRedirect() {
  const { accessToken } = useAuth();
  return <Navigate to={accessToken ? '/dashboard' : '/login'} replace />;
}

const vagFontStack =
  "'VAG', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export default function App() {
  return (
    <ConfigProvider theme={{ token: { fontFamily: vagFontStack } }}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <DashboardLayout />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="languages" element={<LanguagesPage />} />
              <Route path="upasargas" element={<UpasargasPage />} />
              <Route path="subantas" element={<SubantasPage />} />
              <Route path="subanta-view" element={<SubantaViewPage />} />
              <Route path="subanta-rup-formula" element={<SubantaRupFormulaPage />} />
              <Route path="tingantas" element={<TingantasPage />} />
              <Route path="amarkosha" element={<AmarkoshaPage />} />
              <Route path="shiva-sutra" element={<ShivaSutraPage />} />
              <Route path="ashtadhyayi" element={<AshtadhyayiPage />} />
              <Route path="barna" element={<BarnaPage />} />
              <Route path="barna-samuha" element={<BarnaSamuhaPage />} />
              <Route path="pratyahar" element={<PratyaharPage />} />
              <Route path="gana" element={<GanaPage />} />
              <Route path="sutra-commentary" element={<SutraCommentaryPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}
